import { Component } from 'preact';
import PropTypes from 'prop-types';

// Constants
import { pageTypes } from '../../constants/Pages';
import { getStepIndex } from '../../utilities/section/sectionUtils';
import { clone } from '../../utilities/common';
import { setErrorTracking } from '../../utilities/error';

class Page extends Component {
  render() {
    const {
      actions,
      currentProgress,
      loaderProgress,
      pageData,
      price,
      userData,
      pageData: {
        simulateLoading,
        component: {
          componentName,
        },
      },
      initialValues,
      error,
      errorData,
      errorDisplay,
      activeSectionData,
    } = this.props;
    let PageComponent = pageTypes[componentName];
    const newPageData = pageData;
    if (error) {
      // Setup alternative error flow components.
      PageComponent = pageTypes.Page;
      const StepIndex = getStepIndex(pageData, currentProgress);
      if (!errorData.hasOriginal) {
        errorData.original = clone(pageData);
        newPageData.steps[StepIndex].component = errorData.steps;
        newPageData.steps[StepIndex].component.componentName = 'Basic';
        newPageData.steps[StepIndex].component.errorCodeDisplay = errorDisplay;
        errorData.hasOriginal = true;

        // If error do not show the rest of the steps
        newPageData.steps = [newPageData.steps[StepIndex]];

        // Set error tracking here so it will be in sync when the error message is shown.
        setErrorTracking(errorData);
      }
    }
    const pageParams = {
      actions,
      currentProgress,
      loaderProgress,
      pageData: newPageData,
      price,
      simulateLoading,
      userData,
      initialValues,
      activeSectionData,
    };
    return <PageComponent {...pageParams} />;
  }
}

export default Page;

Page.defaultProps = {
  simulateLoading: false,
};

Page.propTypes = {
  userData: PropTypes.object.isRequired,
  pageData: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  loaderProgress: PropTypes.number.isRequired,
  simulateLoading: PropTypes.bool,
  initialValues: PropTypes.object.isRequired,
  error: PropTypes.bool.isRequired,
  errorData: PropTypes.object.isRequired,
  activeSectionData: PropTypes.object.isRequired,
  errorDisplay: PropTypes.string.isRequired,
};
